import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {plural}         from "@Common/ui-components/language/plural";
import {sort}           from "@Common/utils/collections";
import {chain}          from "@Common/utils/fs";

import {OrderSummaryTable} from "../common/order-summary-table/order-summary-table";

export const CartSummaryTable = ({summary, isNDM}) => cs(
    consumeContext("cart"),
    ({cart}) => OrderSummaryTable({
        subtitle: chain(
            cart.value?.items?.length,
            (count) => `Your cart contains ${count ?? 0} ${plural("item", count)}.`,
        ),
        lines: (
            [
                ...chain(
                    summary?.lines??[],
                    (_) => sort(_, (line) => line.order ?? 5),
                ),
            ]
                .filter(v=>v)
        ),
        isNDM
    }),
);
